module.exports = __webpack_public_path__ + "static/media/samplefile_org.66824e9d.csv";


//////////////////
// WEBPACK FOOTER
// ./src/sample/samplefile_org.csv
// module id = 1433
// module chunks = 1